const initialState = {
  documents: undefined,
  busy: false,

  filteringOptions: {},
  activeFilters: {
    documentTypes: [],
    uploaderNames: [],
    documentLocations: [],
    hiddenDocuments: false,
    searchTerm: '',
  },

  // pagination and sorting
  rowsPerPage: 10,
  currentPage: 0,
  sortingField: 'created',
  sortingMode: '-',

  // upload
  isUploading: false,
  lastUploadResult: undefined,
  lastUploadErrorMessage: undefined,
  lastUploadFilename: '',
  lastUploadIdRenaming: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'DOC_CENTER/UPDATE_BUSY':
      return {
        ...state,
        busy: action.status,
      };
    case 'POPULATE_DOCUMENT_CENTER_FILTERING_OPTIONS':
      return {
        ...state,
        filteringOptions: action.filteringOptions,
      };
    case 'POPULATE_DOCUMENT_CENTER_ENTRIES':
      return {
        ...state,
        documents: action.documents,
      };
    case 'SET_DOCUMENT_CENTER_ROWS_PER_PAGE':
      return {
        ...state,
        rowsPerPage: action.rowsPerPage,
      };

    case 'SET_DOCUMENT_CENTER_CURRENT_PAGE':
      return {
        ...state,
        currentPage: action.currentPage,
      };
    case 'UPDATE_DOCUMENT_CENTER_UPLOADING_STATUS':
      return {
        ...state,
        isUploading: action.isUploading,
      };

    case 'UPDATE_DOCUMENT_CENTER_LAST_UPLOAD_RESULT':
      return {
        ...state,
        lastUploadResult: action.lastUploadResult,
        lastUploadErrorMessage: action.lastUploadErrorMessage,
      };

    case 'SET_DOCUMENT_CENTER_LAST_UPLOAD_FILENAME':
      return {
        ...state,
        lastUploadFilename: action.lastUploadFilename,
      };

    case 'SET_DOCUMENT_CENTER_RENAMING_UPLOADED_FILE':
      return {
        ...state,
        lastUploadIdRenaming: action.lastUploadIdRenaming,
      };

    case 'UPDATE_DOCUMENT_CENTER_ACTIVE_FILTERS':
      return {
        ...state,
        activeFilters: action.newFilters,
      };

    case 'CHANGE_DOCUMENT_CENTER_SORTING_FIELD': {
      return {
        ...state,
        sortingField: action.sortingField,
        sortingMode: action.sortingMode,
      };
    }

    default:
      return state;
  }
};
